import { ref } from 'vue';
import axios from 'axios';

export default function useTableApi(props, options) {
    // We assume “page”, “rows”, “filters”, etc. live elsewhere, but we pass them in:
    // Instead of bundling everything here, we’ll accept those refs in arguments.
    function fetchData(params) {
        return axios.get(`/${props.resource}/${props.type}`, { params });
    }
    return { fetchData };
}
